<template>
    <div class="main">
        <router-view
            @show="onShow()"
            @hide="onHide()"
        ></router-view>

        <div v-if="show" class="sectionSingleEditor">
            <div class="containerWrapper">
                <div class="container">

                    <div class="headlineWrapper">
                        <fade-transition @after-enter="onHeadlineShow" :delay="isMobile ? 500 : 0"
                                         :duration="{enter: 500}" appear>
                            <h1 v-show="headlineShow" class="headline headline-h1">
                                {{ editor.name }}
                            </h1>
                        </fade-transition>
                    </div>

                    <div class="content">
                        <fade-transition @after-enter="onReelsShow" :delay="0"
                                         :duration="{enter: 500}" appear>
                            <div v-if="reelsShow" class="singleEditorLinkListContainer">
                                <ul class="singleEditorLinkListWrapper">
                                    <li v-for="reel in editor.reels"
                                        :key="reel.name"
                                        class="singleEditorLinkList">
                                        <h2 v-if="isActiveReel(reel)" :class="classes(reel)">{{ reel.name }}</h2>
                                        <a v-else
                                           :href="reel.link"
                                           :class="classes(reel)"
                                           @click.prevent="onReelClick(reel)"
                                        >
                                            {{ reel.name }}
                                        </a>
                                    </li>
                                </ul>

                            </div>
                        </fade-transition>

                        <media-list
                            :medias="medias"
                            :mediaClass="editor.mediaMarkup"
                            :listClass="'editorVideoListContainer'"
                            v-if="mediasShow">
                        </media-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import {eventBus,} from "../utils/shared";

export default {
    mixins: [],
    data() {
        return {
            show: false,
            headlineShow: false,
            reelsShow: false,
            mediasShow: false,
            hover: null,
        }
    },
    computed: {
        ...mapGetters('ui', [
            'isMobile',
        ]),
        ...mapGetters('editors', [
            'medias',
        ]),
        ...mapState({
            reel: state => state.editors.reel,
            editor: state => state.editors.editor,
        }),
        ...mapState({
            current: state => state.player.current,
        }),
    },
    created() {
    },
    mounted() {
        //debugger
        this.onPlayerOver()

        if (!this.current) {
            this.onShow()
        }
    },
    methods: {
        classes(reel) {
            return [
                'singleEditorLink',
                {'singleEditorLink-current': this.isActiveReel(reel)}
            ]
        },
        isActiveReel(reel) {
            return this.reel.name === reel.name
        },
        onRoute() {
            this.hover = null
        },
        onShow() {
            //console.log('home-detail: onShow')
            if (!this.show) {
                this.show = true
                this.headlineShow = true
            }
        },
        onHeadlineShow() {
            //console.log('editor-detail: onHeadlineShow')
            this.reelsShow = true
        },
        onReelsShow() {
            //console.log('home-detail: onShow')
            this.mediasShow = true
        },
        onHide() {
        },
        onReelClick(reel) {
            this.$store.commit('editors/setReel', reel)

            if (this.$route.name === 'editor-reel') {
                this.$router.push({name: 'editor-reel', params: {editor: this.editor.slug, reel: reel.slug}})
            }
        },
        onPlayerOver() {
            eventBus
                .$off('player.over')
                .$on('player.over', () => {
                    //console.log('player: over')
                    eventBus.$emit('player.back')
                })
        },
    },
    watch: {
        '$route': 'onRoute',
    },
}
</script>

